// TODO v6: rename to gridEditingStateSelector
export var gridEditRowsStateSelector = function gridEditRowsStateSelector(state) {
  return state.editRows;
};